/**
 *
 * FlashCardLanding
 *
 */

import FlashCardItem from '@/views/FlashCard/FlashCardLanding/components/FlashCardItem.vue';
import { FlashCardFavoriteMixin } from '@/scripts/FlashCard/FlashCardLanding/mixins/FlashCardFavoriteMixin';

export default {
  name: 'FlashCardFavorite',

  mixins: [FlashCardFavoriteMixin],

  components: {
    FlashCardItem,
  },
};
